export const HOTEL_LIST_MAX_LENGTH = 25;



// WEBPACK FOOTER //
// ./src/constants/HotelConstants.js